import moment from "moment";

export const HeaderConfig = [
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem?.name}</span>,
  },
  {
    label: "Dealer Name",
    id: "dealerName",
  },
  {
    label: "Dealer Location",
    id: "dealerLocation",
  },
  {
    label: "Shipping Point",
    id: "shippingPoint",
  },
  {
    label: "Equipment Model",
    id: "equipmentModel",
  },
  {
    label: "Profit Center",
    id: "profitCenter",
  },
  {
    label: "Application",
    id: "application",
  },
  {
    label: "Claim Number",
    id: "claimNumber",
  },
  {
    label: "State",
    id: "state",
  },
  {
    label: "Status",
    id: "status",
  },
  {
    label: "Part Value",
    id: "partValue",
  },
  { label: "Claim Reference Number", id: "claimReferenceNumber" },
  {
    label: "Date of Claim Submission",
    id: "claimSubmissionDate",
    render: (data) => {
      return (
        <span>
          {data?.claimSubmissionDate &&
            moment(data.claimSubmissionDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Engine Serial Number",
    id: "engineSerialNumber",
  },
  { label: "Machine Serial Number", id: "machineSerialNumber" },
  {
    label: "Date of Machine Sale",
    id: "machineSaleDate",
    render: (data) => {
      return (
        <span>
          {data?.machineSaleDate &&
            moment(data.machineSaleDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Date of Failure",
    id: "dateOfFailure",
    render: (data) => {
      return (
        <span>
          {data?.dateOfFailure &&
            moment(data.dateOfFailure).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Receipt Date",
    id: "receiptDate",
    render: (data) => {
      return (
        <span>
          {data?.receiptDate && moment(data.receiptDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Hours Covered",
    id: "hoursCovered",
  },
  {
    label: "Customer Complaint",
    id: "customerComplaint",
  },
  {
    label: "Defect Description",
    id: "defectDescription",
  },
  {
    label: "Simpson Part Number",
    id: "simpsonPartNumber",
  },
  {
    label: "Part Number Description",
    id: "partDescription",
  },
  {
    label: "Reason",
    id: "reason",
  },
  {
    label: "Action Taken",
    id: "actionTaken",
  },
  {
    label: "Qty",
    id: "qty",
  },
];
export const SapClaimsHeaderConfig = [
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem}</span>,
  },
  {
    label: "Claim Id",
    id: "claimId",
  },
  { label: "Claim Reference", id: "claimReference" },
  {
    label: "Dealer Name",
    id: "dealerName",
  },
  {
    label: "Dealer Location",
    id: "dealerLocation",
  },
  {
    label: "State",
    id: "state",
  },
  { label: "Equipment Model", id: "equipmentModel" },
  { label: "Application", id: "application" },
  { label: "Engine Serial Number", id: "engineSerialNumber" },
  { label: "Equipment Number", id: "equipmentNumber" },

  {
    label: "Machine Sale Date",
    id: "machineSaleDate",
    render: (data) => {
      return (
        <span>
          {data?.machineSaleDate &&
            moment(data.machineSaleDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Date of Failure",
    id: "failureDate",
    render: (data) => {
      return (
        <span>
          {data?.failureDate && moment(data.failureDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Claim Receipt Date",
    id: "claimReceiptDate",
    render: (data) => {
      return (
        <span>
          {data?.claimReceiptDate &&
            moment(data.claimReceiptDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Customer Complaint",
    id: "customerComplaint",
  },
  { label: "Complaint Description", id: "customerComplaintDescription" },
  {
    label: "Action Taken",
    id: "actionTaken",
  },
  {
    label: "Simpson Part Number",
    id: "simpsonPartNumber",
  },
  {
    label: "Part Number Description",
    id: "partNumberDescription",
  },
  { label: "Status", id: "status" },
  { label: "Remarks", id: "remarks" },
  { label: "List Number", id: "listNumber" },
  {
    label: "Simpson Invoice Date",
    id: "simpsonInvoiceDate",
    render: (data) => {
      return (
        <span>
          {data?.simpsonInvoiceDate &&
            moment(data.simpsonInvoiceDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  { label: "Defect Description", id: "defectDescription" },
  { label: "Part Value", id: "partValue" },
  { label: "Customer Name", id: "customerName" },
  { label: "Customer Return Doc", id: "customerReturnDoc" },
  { label: "Customer Item", id: "customerItem" },
  { label: "Plant", id: "plant" },
  { label: "Shipping Plant", id: "shippingPlant" },
  { label: "Profile Center", id: "profileCenter" },
  { label: "Failure Hours", id: "failureHours" },
  { label: "Credit Note", id: "creditNote" },
  { label: "Defect Code", id: "defectCode" },
  { label: "Plant Responsible", id: "plantResponsible" },
  {
    label: "Qty",
    id: "qty",
  },
];
export const getClaimFormConfig = () => [
  {
    name: "dealerName",
    type: "text",
    label: "Dealer Name",
    placeholder: "Enter Dealer Name",
    required: true,
  },
  {
    name: "claimReferenceNumber",
    type: "text",
    label: "Claim Reference Number",
    placeholder: "Claim Reference NUmber",
    required: true,
  },
  {
    name: "claimSubmissionDate",
    type: "datePicker",
    label: "Claim Submission Date",
    placeholder: "Claim Submission Date",
    required: true,
  },
  {
    name: "engineSerialNumber",
    type: "text",
    label: "Engine Serial Number",
    placeholder: "Engine Serial Number",
    required: true,
  },
  {
    name: "machineSerialNumber",
    type: "text",
    label: "Machine Serial Number",
    placeholder: "Machine Serial Number",
    required: true,
  },
  {
    name: "machineSaleDate",
    type: "datePicker",
    label: "Machine Sale Date",
    placeholder: "Machine Sale Date",
    required: true,
  },
  {
    name: "dateOfFailure",
    type: "datePicker",
    label: "Date of Failure",
    placeholder: "Date of Failure",
    required: true,
  },
  {
    name: "hoursCovered",
    type: "number",
    label: "Hours Covered",
    placeholder: "Hours Covered",
    required: true,
  },
  {
    name: "natureOfComplaint",
    type: "text",
    label: "Nature Of Complaint",
    placeholder: "Nature Of Complaint",
    required: true,
  },
  {
    name: "simpsonPartNumber",
    type: "text",
    label: "Simpson Part Number",
    placeholder: "Part Number",
    required: true,
  },
  {
    name: "qty",
    type: "text",
    label: "Quantity",
    placeholder: "Quantity",
    required: true,
  },
  {
    name: "complaintObservation",
    type: "textarea",
    label: "Complaint Observation",
    placeholder: "Complaint Observation",
    required: true,
    fieldGridSize: 6,
  },
  {
    name: "partNumberDescription",
    type: "textarea",
    label: "Part Number Description",
    placeholder: "Part Number Description",
    required: true,
    fieldGridSize: 6,
  },
];
